import React from 'react';
import {View} from 'react-native';

import InlineFormattedNumber from '/component/base/FormattedNumber/InlineFormattedNumber';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {BonusesID} from '/constant/TestIDs';
import {generateCallback} from '/util/component.util';

import testProperties from '../../../../util/testing/testProperties';
import {NO_VALUE} from '../Bonuses.hook';

import {styles} from './Tile.style';
import {TileProps} from './Tile.types';

export const Tile = ({
  amount = 0,
  description = '',
  onPress = () => {},
  selectedIndex = NO_VALUE,
  currentIndex = 0,
  currencyCode = 'USD',
  colorScale = [],
}: TileProps) => {
  const tileColor = {backgroundColor: colorScale[currentIndex]};

  return (
    <TouchableOpacity
      key={description}
      style={[
        styles.base,
        selectedIndex === currentIndex && styles.selectedBase,
      ]}
      onPress={generateCallback({func: onPress, params: currentIndex})}
      {...testProperties(description, true)}>
      <View style={styles.titleContainer}>
        <View style={[styles.colorIndicator, tileColor]} />
        <Text
          variant="body"
          style={styles.title}
          {...testProperties(BonusesID.bonusTileDescription)}>
          {description}
        </Text>
      </View>
      <InlineFormattedNumber
        // @ts-expect-error TS(2322): Type '{ variant: string; value: any; decimalPlaces... Remove this comment to see the full error message
        variant="button"
        value={amount}
        decimalPlaces={2}
        currencyCode={currencyCode}
        testID={BonusesID.bonusTileValue}
      />
    </TouchableOpacity>
  );
};
